const handleFormJustVoting = function () {
  const wrappers = document.querySelectorAll('.form__wrapper_just_vote');

  if (wrappers.length > 0) {
    wrappers.forEach((wrapper) => {
      const submitBtns = wrapper.querySelectorAll('.send-just-vote');

      submitBtns.forEach((btn) => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();

          // W obrębie danego bloku teaser znajdź właściwy tytuł
          const teaser = btn.closest('.teaser--vote');
          const selectedCarEl = teaser.querySelector('.teaser__text > h4');
          const selectedCar = selectedCarEl ? selectedCarEl.innerText.trim() : '';

          // Przygotowanie danych
          const data = {
            selectedCar: selectedCar,
            button: 'vote'
          };

          let formIsValid = true;
          // Możesz dodać dodatkową walidację

          if (formIsValid && data.selectedCar) {
            // Pobierz element formularza w obrębie wrappera
            const formEl = wrapper.querySelector('form');
            const url = formEl.getAttribute('data-url');

            fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(data),
            })
              .then((response) => response.text())
              .then((html) => {
                document.querySelectorAll('.btn-just-vote').forEach((btn) => {
                  btn.setAttribute('disabled', 'true');
                });

                // 2) znajdź i kliknij właściwy teaser
                const teasersArray = Array.from(document.querySelectorAll('.teaser--vote'));
                const myTeaser = teasersArray.find(t => {
                  const h4 = t.querySelector('.teaser__text > h4');
                  return h4 && h4.textContent.trim() === selectedCar;
                });
                if (!myTeaser) {
                  console.warn('🚨 Nie znalazłem teaser‑a dla', selectedCar);
                  return;
                }
                const voteBtn = myTeaser.querySelector('button.btn-main.btn--vote');
                if (!voteBtn) {
                  console.warn('🚨 Brak przycisku głosowania');
                  return;
                }

                // 3) znajdź istniejący div.article__form (on jest pod .teasers, ale ukryty)
                const articleFormDiv = document.querySelector('.article__form');
                if (!articleFormDiv) {
                  console.warn('🚨 Brak .article__form w DOM');
                  return;
                }

                // 4) przygotuj obserwator, który wykryje zmianę widoczności
                const mo = new MutationObserver((mutations, observer) => {
                  // sprawdź, czy teraz jest widoczny
                  const style = getComputedStyle(articleFormDiv);
                  const isVisible = articleFormDiv.classList.contains('form--visible') || style.display !== 'none';
                  if (!isVisible) return;

                  console.log('🔍 Formularz się otworzył — wstrzykuję HTML');
                  const form = articleFormDiv.querySelector('form.form__fields');
                  if (form) {
                      // jeżeli użytkownik już wysłał zgłoszenie, to zwrotka z serwera ma być jedynym komunikatem
                      const statusUrl = form.dataset.status;
                      if (statusUrl) {
                      fetch(statusUrl)
                      .then((response) => response.json())
                      .then(userStatus => {
                        const { isLogged, voted, registered } = userStatus;
                        // jeżeli użytkownik już wysłał zgłoszenie, to zwrotka z serwera ma być jedynym komunikatem
                        if (registered) { 
                          form.innerHTML = html; // Zastępuje całą zawartość formularza
                        }
                        // w przeciwnym wypadku wstaw zwrotkę z serwera na początku formularza
                        else {
                          form.insertAdjacentHTML('afterbegin', html);
                        }
                      })
                      .catch((err) => {
                        console.error('Błąd podczas pobierania danych użytkownika:', err);
                      });
                    }
                    // w przeciwnym wypadku wstaw zwrotkę z serwera na początku formularza
                    else {
                      form.insertAdjacentHTML('afterbegin', html);
                    }
                  } else {
                    console.warn('🚨 Nie znalazłem <form class="form__fields"> wewnątrz .article__form');
                  }
                  observer.disconnect();
                });

                // obserwujemy zmiany atrybutów klasy/style na tym divie
                mo.observe(articleFormDiv, { attributes: true, attributeFilter: ['class', 'style'] });

                // 5) w końcu klikamy — to uruchomi logikę pokazywania formularza
                voteBtn.click();

                document.querySelectorAll('.btn--vote').forEach((btn) => {
                  btn.setAttribute('disabled', 'true');
                });
              })
              .catch((err) => {
                console.error('Błąd podczas wysyłania głosu:', err);
              });
          }
        });
      });
    });
  }
};

handleFormJustVoting();
